import React, { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

// نص بيتقص بـ "..." لو طويل، وأول ما الماوس يقف عليه يظهر النص كامل في tooltip.
// الـ tooltip بيظهر بس لو النص فعلاً متقصوص، وبيترسم في body عشان مايتقصش جوه الجداول.
const TruncatedText = ({ text, children, style, className = '', as: Tag = 'div', lines = 1 }) => {
    const ref = useRef(null);
    const timerRef = useRef(null);
    const [tip, setTip] = useState(null);
    const content = children ?? text;
    const fullText = String(text ?? (typeof children === 'string' ? children : '') ?? '');

    const isTruncated = () => {
        const el = ref.current;
        if (!el) return false;
        return el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
    };

    const show = () => {
        if (!fullText.trim() || !isTruncated()) return;
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => {
            const rect = ref.current?.getBoundingClientRect();
            if (!rect) return;
            const below = rect.bottom + 8 + 120 < window.innerHeight;
            setTip({
                top: below ? rect.bottom + 6 : rect.top - 6,
                left: Math.min(Math.max(rect.left, 12), window.innerWidth - 12),
                width: rect.width,
                below,
            });
        }, 120);
    };

    const hide = useCallback(() => {
        window.clearTimeout(timerRef.current);
        setTip(null);
    }, []);

    useEffect(() => {
        if (!tip) return undefined;
        window.addEventListener('scroll', hide, true);
        window.addEventListener('resize', hide);
        return () => {
            window.removeEventListener('scroll', hide, true);
            window.removeEventListener('resize', hide);
        };
    }, [hide, tip]);

    useEffect(() => () => window.clearTimeout(timerRef.current), []);

    const clampStyle = lines > 1
        ? { display: '-webkit-box', WebkitLineClamp: lines, WebkitBoxOrient: 'vertical', overflow: 'hidden' }
        : { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

    return (
        <>
            <Tag
                ref={ref}
                className={className}
                style={{ minWidth: 0, ...clampStyle, ...style }}
                onMouseEnter={show}
                onMouseLeave={hide}
                onFocus={show}
                onBlur={hide}
            >
                {content}
            </Tag>
            {tip && createPortal(
                <div
                    role="tooltip"
                    dir="auto"
                    style={{
                        position: 'fixed',
                        top: tip.top,
                        left: tip.left,
                        transform: tip.below ? 'none' : 'translateY(-100%)',
                        zIndex: 10050,
                        maxWidth: `min(460px, calc(100vw - ${Math.round(tip.left) + 12}px))`,
                        minWidth: Math.min(tip.width, 220),
                        padding: '8px 12px',
                        borderRadius: 10,
                        background: '#0f172a',
                        color: '#fff',
                        fontSize: 12,
                        fontWeight: 600,
                        lineHeight: 1.6,
                        whiteSpace: 'normal',
                        overflowWrap: 'anywhere',
                        boxShadow: '0 10px 30px rgba(15,23,42,0.25)',
                        pointerEvents: 'none',
                        fontFamily: "'Cairo', 'Segoe UI', sans-serif",
                    }}
                >
                    {fullText}
                </div>,
                document.body
            )}
        </>
    );
};

export default TruncatedText
